module.exports = __webpack_public_path__ + "static/slide-2-da907576c710ea491241c32fc677fb89.png";